export enum NavigateAction {
  BACK,
  FORWARD,
  RELOAD,
  PUSH_PAGE,
  CHANGE_TAB
}
